import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import TemplateMenu from './TemplateMenu.vue';
let TemplateBody = class TemplateBody extends Vue {
};
TemplateBody = __decorate([
    Component({
        components: { TemplateMenu }
    })
], TemplateBody);
export default TemplateBody;
